var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgMarvel = function SvgMarvel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#1FB6FF",
    fillRule: "evenodd",
    d: "M16 30c7.732 0 14-6.268 14-14S23.732 2 16 2 2 8.268 2 16s6.268 14 14 14Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M14.605 12.921c1.025.011-.78 5.333-.586 7.646.195 2.334 2.778 1.662 2.614.319-.279-2.284 1.243-9.442 2.786-9.442 1.082 0-1.2 4.934-.75 8.094.297 2.09 2.993 1.365 2.719.126-.906-4.103 1.902-8.045 1.587-10.838-.137-1.222-.872-1.82-1.608-1.826-2.574-.02-4.562 5.26-4.562 5.26s.207-3.001-1.794-3.111c-3.063-.17-6.095 7.497-6.01 14.342.028 2.183 2.746 1.811 2.603.07-.266-3.237 1.54-10.655 3-10.64Z",
    clipRule: "evenodd"
  })));
};
export default SvgMarvel;